import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "../../elements/language";
import logo from "../../../images/public/innopark24-logo.png";
import "./rent.css";

export const LanguageSwitch = () => {
  const { t } = useTranslation();
  return <LanguageDropdown label={t("rpLanguage")} />;
};

// Kopfzeile aller Rent-Seiten: Logo, Navigation, Sprache
const RentHeader = () => {
  const { t } = useTranslation();
  return (
    <header className="rx-top">
      <div className="rx-top-in">
        <Link to="/" aria-label="innopark24">
          <img className="rx-logo" src={logo} alt="innopark24" />
        </Link>
        <nav className="rx-nav" aria-label={t("rxNav")}>
          <NavLink to="/" end>
            {t("rxNavFind")}
          </NavLink>
          <NavLink to="/pay">{t("rxNavHere")}</NavLink>
          <NavLink to="/meine-buchungen">{t("rxNavMy")}</NavLink>
        </nav>
        <LanguageSwitch />
      </div>
    </header>
  );
};

export const RentFooter = ({ className = "rx-foot" }) => {
  const { t } = useTranslation();
  return (
    <footer className={className}>
      <div className="rx-foot-in">
        <span>© innopark24</span>
        <Link to="/meine-buchungen">{t("rxNavMy")}</Link>
        <a href="https://innopark24.com/impressum/">{t("imprint")}</a>
        <a href="https://innopark24.com/datenschutz/">{t("privacy")}</a>
        <a href="https://innopark24.com/faq/">FAQ</a>
      </div>
    </footer>
  );
};

export default RentHeader;
